import React, { Component } from "react";
import moment from "moment";

import { getRequest, postRequest, putRequest } from "../../api/ApiService";
import PeerEvaluationCard from "./peer-evaluation-card";
import PeerEvaluationModal from "./peer-evaluation-modal";
import PeerEvaluationFeedback from "./peer-evaluation-feedback";
import Auth from "../../routes/Auth";
import sortBy from "lodash/sortBy";
import WarningAlert from "../alerts/warning";
import ErrorAlert from "../alerts/error";
import Loader from "react-loaders";

class PeerEvaluation extends Component {
  constructor(props) {
    super(props);

    const userId = parseInt(Auth.getUserId(), 10);
    let readonlyMode = this.props.viewOnly;
    if (typeof readonlyMode === 'undefined') {
      readonlyMode = !this.isSurveyStarted(props.survey);
    }

    this.state = {
      currentUserId: userId,
      currentTeamId: Auth.getTeamId(),
      readonlyMode,
      finishedFeedbacks: [],
      feedbacks: {},
      questionsOrder: [],
      answers: [],
      isIntroScreen: true,
      isFinalScreen: false,
      isBeforeTransitionScreen: false,
      isTransitionScreen: false,
      currentPage: 0,
      questionsCount: 0,
      self_assessment_count: 0,
      peer_rating_count: 0,
      skills_assessment_count: 0,
      final_reflection_count: 0,
      showFeedbackError: false,
      show: false,
      progressBar: [],
      teamList: [],
      submitPages: {},
      showAlert: false,
      adjustedScore: 0,
      submitButtonLoading: false,
      showSubmissionError: false
    };
  }

  async componentDidMount() {
    const { survey } = this.props;
    await this.getTeamList();

    const finishedFeedbacks = await this.getFinishedFeedbacks();

    let progressBar = [
      { id: 1, title: "1. Self Assessment", progress: 0 },
      {
        id: 2,
        title: "2. Peer Rating",
        progress: 0,
        isDisabled: true
      }
    ];

    const isFinalReflectionsVisible = this.isFinalReflectionsVisible(survey.questions);

    if (this.isSkillsAssessmentVisible(survey.questions)) {
      progressBar.push({ id: 3, title: "3. Skills Assessment", progress: 0, isDisabled: true });

      if (isFinalReflectionsVisible) {
        progressBar.push({ id: 4, title: "4. Final Reflections", progress: 0, isDisabled: true });
      }
    } else {
      if (isFinalReflectionsVisible) {
        progressBar.push({ id: 4, title: "3. Final Reflections", progress: 0, isDisabled: true });
      }
    }


    this.setState({
      finishedFeedbacks,
      progressBar
    });
  }

  async getTeamList() {
    const { currentUserId, currentTeamId } = this.state;
    const { body: users } = await getRequest(
      `${process.env.REACT_APP_API_URL}team/players/?team=${currentTeamId}`
    );

    const teamList = sortBy(users.filter(
      teammate => teammate.role !== 'VI'
        && teammate.team === currentTeamId
        && teammate.user
        && teammate.user.id !== currentUserId
    ).map(teammate => teammate.user), "id")
      .map(teammate => {
        return {
          id: teammate.id,
          username: teammate.username,
          fullname: `${teammate.first_name} ${teammate.last_name}`
        };
      });

    this.setState({
      teamList,
    }, () => {
      this.questionsOrder();
    });
  }

  async getFeedback(sendData, finishedFeedbacks) {
    const { readonlyMode } = this.state;

    let feedback = finishedFeedbacks.find(i => (
      i.survey === sendData.survey
      && i.giver === sendData.giver
      && i.giver_team === sendData.giver_team
      && i.receiver === sendData.receiver
    ));
    if (!feedback && readonlyMode === false) {
      const { body } = await postRequest(
        `${process.env.REACT_APP_API_URL}v2/forms/feedbacks/`
      ).send(sendData);
      feedback = body;
    }

    return feedback;
  }

  async getFinishedFeedbacks() {
    const { survey } = this.props;
    const { body: finishedFeedbacks } = await getRequest(
      `${process.env.REACT_APP_API_URL}v2/forms/feedbacks/`
    );

    return finishedFeedbacks.results.filter(i => i.survey === survey.id);
  }

  async loadFeedback() {
    const { survey } = this.props;
    const {
      currentUserId,
      currentTeamId,
      teamList,
      self_assessment_count,
      peer_rating_count,
      skills_assessment_count,
      final_reflection_count,
    } = this.state;
    const data = {
      survey: survey.id,
      giver: currentUserId,
      giver_team: currentTeamId
    };

    const feedbacksData = [
      currentUserId,
      ...(teamList.map(teammate => teammate.id))
    ].map(userId => ({
      ...data,
      receiver: userId,
    }));
    const finishedFeedbacks = await this.getFinishedFeedbacks();

    const feedbacks = {};
    const feedbacksIds = [];
    for (const feedbackData of feedbacksData) {
      const feedback = await this.getFeedback(feedbackData, finishedFeedbacks);
      feedbacks[feedbackData.receiver] = feedback;
      feedbacksIds.push(feedback.id);
    }
    const { body: answersData } = await getRequest(
      `${process.env.REACT_APP_API_URL}v2/forms/answers/`
    );

    const answers = [];
    if (answersData && answersData.length > 0 && feedbacksIds.length > 0) {
      answersData
        .filter(answer => feedbacksIds.includes(answer.feedback))
        .forEach(answer => {
          const question = survey.questions.find(
            q => q.id === answer.survey_question
          );
          answers.push({
            id: answer.id,
            value:
              question.answer_type === "rating"
                ? parseInt(answer.text, 10)
                : answer.text,
            hasError: false,
            type: "text",
            isModified: false,
            survey_question: answer.survey_question,
            feedback: answer.feedback,
          });
        });
    }

    const submitPages = {};
    if (feedbacks[currentUserId]) {
      submitPages[self_assessment_count] = feedbacks[currentUserId];
    }

    for (let i = 0; i < teamList.length; i++) {
      const teammate = teamList[i];
      if (feedbacks[teammate.id]) {
        let index = (i + 1) * (final_reflection_count) / teamList.length + self_assessment_count + peer_rating_count + skills_assessment_count + 2;
        submitPages[index] = feedbacks[teammate.id];
      }
    }

    this.setState({
      feedbacks,
      answers,
      finishedFeedbacks,
      submitPages,
    });
  }

  pasteTeamateName = (text, name) => {
    let result = text;
    const replacements = ['this teammate', '<insert teammate name>', '<insert name>', '<Insert User FirstName>'];
    for (const replacement of replacements) {
      result = result.replace(replacement, `<span>${name}</span>`);
    }

    return result;
  }

  formatFinalReflectionTitle = (text, name) => {
    const likeStyle = 'color: #55B4BC;';
    const wishStyle = 'color: #ECA427;';

    return this.pasteTeamateName(text, name)
      .replace('I Like', `<span style="${likeStyle}">I Like</span>`)
      .replace('I Wish', `<span style="${wishStyle}">I Wish</span>`);
  }

  questionsOrder = () => {
    const { survey } = this.props;
    const { teamList } = this.state;
    const questions = survey.questions;

    const self_assessment_questions = questions.filter(
      question => question.category === "self_assessment"
    );

    const peer_rating_questions = questions.filter(
      question =>
        question.category === "collaboration" ||
        question.category === "peer_rating"
    );

    let skills_assessment_questions = [];
    const skills_assessment_base_questions = questions.filter(
      question =>
        question.category === "skills" ||
        question.category === "other"
    );

    const isSkillsAssessmentVisible = this.isSkillsAssessmentVisible(survey.questions);
    if (isSkillsAssessmentVisible) {
      for (let i = 0; i < teamList.length; i++) {
        const teammate = teamList[i];

        if (i < teamList.length) {
          skills_assessment_questions.push({
            answer_type: "transition_page",
            username: teammate.fullname,
          });
        }

        skills_assessment_questions = [
          ...skills_assessment_questions,
          ...skills_assessment_base_questions.map(q => ({
            ...q,
            text: this.pasteTeamateName(q.text, teammate.fullname),
            userId: teammate.id,
          })),
        ];
      }
    }

    let final_reflection_questions = [];
    const final_reflection_base_questions = questions.filter(
      question =>
        question.category === "communication" &&
        question.answer_type === "freeform"
    );

    for (let i = 0; i < teamList.length; i++) {
      const teammate = teamList[i];

      if (i < teamList.length) {
        final_reflection_questions.push({
          answer_type: "transition_page",
          username: teammate.fullname,
        });
      }

      final_reflection_questions = [
        ...final_reflection_questions,
        ...final_reflection_base_questions.map(q => ({
          ...q,
          text: this.formatFinalReflectionTitle(q.text, teammate.fullname),
          userId: teammate.id,
        })),
      ];
    }

    let questionsOrder = [
      { answer_type: "self_assessment_intro" },
      ...self_assessment_questions,
      { answer_type: "peer_rating_intro" },
      ...peer_rating_questions
    ];

    if (isSkillsAssessmentVisible)
      questionsOrder.push(
        { answer_type: "skills_assessment_intro" },
        ...skills_assessment_questions);

    if (this.isFinalReflectionsVisible(survey.questions))
      questionsOrder.push(
        { answer_type: "final_reflections_intro" },
        ...final_reflection_questions);

    questionsOrder.push({ answer_type: "final_page" });

    this.setState(() => ({
      questionsOrder,
      questionsCount: questionsOrder.length - 1,
      self_assessment_count: self_assessment_questions.length,
      peer_rating_count: peer_rating_questions.length,
      skills_assessment_count: skills_assessment_questions.length,
      final_reflection_count: final_reflection_questions.length
    }));
  };

  isSkillsAssessmentVisible = questions => {
    return questions.filter(question => (question.category === 'other' || question.category === 'skills') && question.answer_type === 'freeform').length > 0;
  }

  isFinalReflectionsVisible = questions => {
    return questions.filter(question => question.category === 'communication' && question.answer_type === 'freeform').length > 0;
  }

  isSurveyEnded = survey => {
    const endDate = moment(survey.end);
    const currentDate = moment.utc();

    return currentDate.isSameOrAfter(endDate);
  };

  isSurveyEndedWithExtended = survey => {
    const endDate = moment(survey.end);
    const endDateWithExtendedTime = moment(survey.end).add(survey.extended_time, 'hours');
    const currentDate = moment.utc();

    const endDatePassed = currentDate.isSameOrAfter(endDate);
    const endDateWithExtendedTimePassed = currentDate.isSameOrAfter(endDateWithExtendedTime);

    if (endDatePassed) {
      if (!endDateWithExtendedTimePassed) {
        return this.isSurveyCompleted();
      }
      return true;
    }

    return false;
  };

  isSurveyCompleted = () => {
    const { finishedFeedbacks } = this.state;
    const notCompletedSurveyFormsFeedbacks = finishedFeedbacks.filter(i => i.completed === false);

    return !!(finishedFeedbacks.length && !notCompletedSurveyFormsFeedbacks.length);
  };

  isSurveySubmitted = () => {
    const { currentUserId, teamList, finishedFeedbacks } = this.state;
    const feedbacks = finishedFeedbacks.filter(i => i.completed === true);
    const teammates = [
      ...teamList.map(i => i.id),
      currentUserId,
    ];

    let feedbackExists = true;
    for (const teammate of teammates) {
      const feedback = feedbacks.find(i => i.receiver === teammate);
      if (!feedback) {
        feedbackExists = false;
        break;
      }
    }

    return feedbackExists;
  };

  isSurveyHasFeedbacks = () => {
    const { finishedFeedbacks } = this.state;

    return finishedFeedbacks.length;
  };

  isSurveyStarted = survey => {
    const startDate = moment(survey.start);
    const endDate = moment(survey.end);
    const currentDate = moment.utc();

    return (
      currentDate.isSameOrAfter(startDate) &&
      currentDate.isSameOrBefore(endDate.add(survey.extended_time, 'hours'))
    );
  };

  isIntroScreen = nextPage => {
    const { questionsOrder } = this.state;
    const type = questionsOrder[nextPage].answer_type;

    return (
      type === "self_assessment_intro" ||
      type === "peer_rating_intro" ||
      type === "skills_assessment_intro" ||
      type === "final_reflections_intro"
    );
  };

  isFinalScreen = nextPage => {
    const { questionsOrder } = this.state;
    const type = questionsOrder[nextPage].answer_type;

    return type === "final_page";
  }

  isBeforeTransitionScreen = nextPage => {
    const { questionsOrder } = this.state;
    const currentType = questionsOrder[nextPage].answer_type;
    const nextType = questionsOrder[nextPage + 1] ? questionsOrder[nextPage + 1].answer_type : null;

    return (currentType === "self_assessment_intro"
      || currentType === "peer_rating_intro"
      || currentType === "skills_assessment_intro"
      || currentType === "final_reflections_intro")
      && nextType === "transition_page";
  }

  isTransitionScreen = nextPage => {
    const { questionsOrder } = this.state;
    const type = questionsOrder[nextPage].answer_type;

    return type === "transition_page";
  }

  handleShowModal = () => {
    this.setState(
      () => ({ show: true }),
      () => {
        this.loadFeedback();
      }
    );
  };

  handleHideModal = () => {
    const { survey } = this.props;
    getRequest(`${process.env.REACT_APP_API_URL}v2/forms/feedbacks`)
      .then(res => {
        const formsFeedbacks = res.body.results;
        const notCompletedSurveyFormsFeedbacks = formsFeedbacks.filter(formsFeedback => formsFeedback.survey === survey.id && formsFeedback.completed !== true);
        if (notCompletedSurveyFormsFeedbacks.length && Auth.getPosition() === 'Student') {
          this.showAlert();
        } else {
          this.resetPeerEvaluationPages();
        }
      })
      .catch(err => { });
  };

  showAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  hideAlert = () => {
    this.setState({
      showAlert: false,
    }, () => this.resetPeerEvaluationPages());
  };

  showSubmissionError = () => {
    this.setState({
      showSubmissionError: true,
    });
  };

  hideSubmissionError = () => {
    this.setState({
      showSubmissionError: false,
    });
  };

  resetPeerEvaluationPages = () => {
    this.setState(prevState => ({
      show: false,
      currentPage: 0,
      isIntroScreen: true,
      isFinalScreen: false,
      isBeforeTransitionScreen: false,
      isTransitionScreen: false,
      submitPages: {},
      progressBar: prevState.progressBar.map(item => ({ ...item, progress: 0, isDisabled: item.id > 1 }))
    }));
  }

  goToNextPage = () => {
    const {
      currentPage,
      questionsCount,
      self_assessment_count,
      peer_rating_count,
      skills_assessment_count,
      final_reflection_count,
      questionsOrder,
      answers,
      submitPages,
      readonlyMode,
      feedbacks
    } = this.state;

    const { survey } = this.props;

    const currentQuestionId = questionsOrder[currentPage].id;
    const currentAnswers = answers.filter(answer => !!currentQuestionId && answer.survey_question === currentQuestionId);
    const hasError = !readonlyMode ? currentAnswers.some(answer => answer.hasError === true) : false;

    let nextPage = hasError ? currentPage : currentPage + 1;
    if (nextPage > questionsCount) {
      nextPage = questionsCount;
    }

    if (!hasError && !readonlyMode) {
      this.sendAnswers();
    }

    if (!readonlyMode && submitPages[currentPage] && submitPages[currentPage].completed === false) {
      putRequest(
        `${process.env.REACT_APP_API_URL}v2/forms/feedbacks/${submitPages[currentPage].id}/`
      ).send({
        giver: submitPages[currentPage].giver,
        giver_team: submitPages[currentPage].giver_team,
        receiver: submitPages[currentPage].receiver,
        survey: submitPages[currentPage].survey,
        completed: true,
      })
        .then(() => { })
        .catch(() => { });
    }

    const isIntroScreen = this.isIntroScreen(nextPage);
    const isFinalScreen = this.isFinalScreen(nextPage);
    const isBeforeTransitionScreen = this.isBeforeTransitionScreen(nextPage);
    const isTransitionScreen = this.isTransitionScreen(nextPage);

    let adjustedScore = 0;
    if (!readonlyMode && currentPage === (questionsCount - 1)) {
      const feedbackPromises = Object.keys(feedbacks).map(feedbackId => {
        if (feedbacks[feedbackId].completed !== true) {
          return putRequest(`${process.env.REACT_APP_API_URL}v2/forms/feedbacks/${feedbacks[feedbackId].id}/`)
            .send({
              ...feedbacks[feedbackId],
              completed: true
            })
            .then(() => { })
            .catch(() => { });
        } else {
          return Promise.resolve(); // Skip if already completed
        }
      });

      Promise.all(feedbackPromises)
        .then(() => {
          // All feedback requests have completed, now make the post request
          postRequest(`${process.env.REACT_APP_API_URL}v2/forms/surveys/${survey.id}/submission-scoring/`)
            .then(async () => {
              const maxAttempts = 3;
              let attempt = 1;
              this.setState({
                submitButtonLoading: true
              });

              while (attempt <= maxAttempts) {
                if (attempt > 1) {
                  await new Promise(resolve => setTimeout(resolve, 2500));
                }

                try {
                  const userId = Auth.getUserId();
                  const res = await getRequest(`${process.env.REACT_APP_API_URL}v2/forms/feedback-submission-scores/${userId}/${survey.id}`);
                  const feedbackSubmissionScores = res.body;

                  const adjustedScore = feedbackSubmissionScores.adjusted_score;

                  this.setState({
                    submitButtonLoading: false,
                  }, () => this.setGoToNextPageState(nextPage, isIntroScreen, isFinalScreen, isBeforeTransitionScreen, isTransitionScreen, self_assessment_count, peer_rating_count, skills_assessment_count, final_reflection_count, hasError, adjustedScore));
                  break;
                } catch (err) {
                  if (attempt >= maxAttempts) {
                    this.setState({
                      submitButtonLoading: false
                    }, () => this.showSubmissionError());
                    break;
                  }

                  attempt++;
                }
              }
            })
            .catch(() => { });
        });
    } else {
      this.setGoToNextPageState(nextPage, isIntroScreen, isFinalScreen, isBeforeTransitionScreen, isTransitionScreen, self_assessment_count, peer_rating_count, skills_assessment_count, final_reflection_count, hasError, adjustedScore);
    }
  };

  setGoToNextPageState = (
    nextPage,
    isIntroScreen,
    isFinalScreen,
    isBeforeTransitionScreen,
    isTransitionScreen,
    self_assessment_count,
    peer_rating_count,
    skills_assessment_count,
    final_reflection_count,
    hasError,
    adjustedScore
  ) => {
    const finalReflectionsProgressAdjuster = skills_assessment_count ? 3 : 2;
    const finalReflectionsDisabledAdjuster = skills_assessment_count ? 2 : 1;
    this.setState(prevState => ({
      currentPage: nextPage,
      isIntroScreen,
      isFinalScreen,
      isBeforeTransitionScreen,
      isTransitionScreen,
      showFeedbackError: hasError,
      adjustedScore,
      progressBar: prevState.progressBar.map(item =>
        item.id === 1
          ? {
            ...item,
            progress: Math.min((nextPage / self_assessment_count) * 100, 100)
          }
          :
          item.id === 2
            ? {
              ...item,
              progress: Math.min((Math.max(nextPage - self_assessment_count - 1, 0) / peer_rating_count) * 100, 100),
              isDisabled: nextPage <= self_assessment_count
            }
            :
            item.id === 3
              ? {
                ...item,
                progress: Math.min((Math.max(nextPage - self_assessment_count - peer_rating_count - 2, 0) / skills_assessment_count) * 100, 100),
                isDisabled: nextPage <= self_assessment_count + peer_rating_count + 1
              }
              : item.id === 4
                ? {
                  ...item,
                  progress: Math.min((Math.max(nextPage - self_assessment_count - peer_rating_count - skills_assessment_count - finalReflectionsProgressAdjuster, 0) / final_reflection_count) * 100, 100),
                  isDisabled: nextPage <= self_assessment_count + peer_rating_count + skills_assessment_count + finalReflectionsDisabledAdjuster
                }
                : item
      )
    }));
  }

  goToPrevPage = () => {
    const {
      currentPage,
      self_assessment_count,
      peer_rating_count,
      skills_assessment_count,
      final_reflection_count,
      questionsOrder,
      answers,
      readonlyMode,
    } = this.state;

    const currentQuestionId = questionsOrder[currentPage].id;
    const currentAnswers = answers.filter(answer => !!currentQuestionId && answer.survey_question === currentQuestionId);
    const hasError = !readonlyMode ? currentAnswers.some(answer => answer.hasError === true) : false;

    let prevPage = hasError ? currentPage : currentPage - 1;
    if (prevPage < 1) {
      prevPage = 1;
    }

    if (!hasError && !readonlyMode) {
      this.sendAnswers();
    }

    const isIntroScreen = this.isIntroScreen(prevPage);
    const isFinalScreen = this.isFinalScreen(prevPage);
    const isBeforeTransitionScreen = this.isBeforeTransitionScreen(prevPage);
    const isTransitionScreen = this.isTransitionScreen(prevPage);

    const finalReflectionsProgressAdjuster = skills_assessment_count ? 3 : 2;
    const finalReflectionsDisabledAdjuster = skills_assessment_count ? 2 : 1;
    this.setState(prevState => ({
      currentPage: prevPage,
      isIntroScreen,
      isFinalScreen,
      isBeforeTransitionScreen,
      isTransitionScreen,
      showFeedbackError: hasError,
      progressBar: prevState.progressBar.map(item =>
        item.id === 1
          ? {
            ...item,
            progress: Math.min((prevPage / self_assessment_count) * 100, 100)
          }
          :
          item.id === 2
            ? {
              ...item,
              progress: Math.min((Math.max(prevPage - self_assessment_count - 1, 0) / peer_rating_count) * 100, 100),
              isDisabled: prevPage <= self_assessment_count
            }
            :
            item.id === 3
              ? {
                ...item,
                progress: Math.min((Math.max(prevPage - self_assessment_count - peer_rating_count - 2, 0) / skills_assessment_count) * 100, 100),
                isDisabled: prevPage <= self_assessment_count + peer_rating_count + 1
              }
              : item.id === 4
                ? {
                  ...item,
                  progress: Math.min((Math.max(prevPage - self_assessment_count - peer_rating_count - skills_assessment_count - finalReflectionsProgressAdjuster, 0) / final_reflection_count) * 100, 100),
                  isDisabled: prevPage <= self_assessment_count + peer_rating_count + skills_assessment_count + finalReflectionsDisabledAdjuster
                }
                : item
      )
    }));
  };

  async sendAnswers() {
    const { questionsOrder, currentPage, answers } = this.state;

    const currentQuestion = questionsOrder[currentPage];
    const currentQuestionId = currentQuestion ? currentQuestion.id : null;

    if (currentQuestionId) {
      const changedAnswers = answers.filter(i => i.survey_question === currentQuestionId && i.isModified === true);
      if (changedAnswers.length > 0) {
        for (const answer of changedAnswers) {
          if (answer.id === 0) {
            await postRequest(
              `${process.env.REACT_APP_API_URL}v2/forms/answers/`
            ).send({
              feedback: answer.feedback,
              survey_question: answer.survey_question,
              text: answer.value
            });
          } else {
            await putRequest(
              `${process.env.REACT_APP_API_URL}v2/forms/answers/${answer.id}/`
            ).send({
              feedback: answer.feedback,
              survey_question: answer.survey_question,
              text: answer.value
            });
          }
        }

        const newAnswers = [...answers].map(answer => ({
          ...answer,
          isModified: false,
        }));
        this.setState({
          answers: newAnswers,
        });
      }
    }
  }

  handleFeedbackOnChange = result => {
    const { answers, showFeedbackError } = this.state;
    const { id, feedback, ...rest } = result;

    if (feedback) {
      const hasError = result.hasError ? showFeedbackError : false;
      const answerIndex = answers.findIndex(i => i.survey_question === id && i.feedback === feedback);
      let newAnswers = [...answers];
      if (answerIndex >= 0) {
        newAnswers[answerIndex] = {
          id: answers[answerIndex].id,
          survey_question: id,
          feedback,
          ...rest,
          isModified: true,
        };
      } else {
        newAnswers.push({
          id: 0,
          survey_question: id,
          feedback,
          ...rest,
          isModified: true,
        });
      }

      this.setState({
        answers: newAnswers,
        showFeedbackError: hasError,
      });
    }
  };

  getPreviousAnswers = (currentPage, userId) => {
    const { questionsOrder, answers, feedbacks } = this.state;
    if (!userId) {
      return [];
    }

    const pages = Object.keys(questionsOrder).map(page => Number(page));
    const filteredPages = pages
      .filter(page => page < currentPage)
      .map(page => questionsOrder[page])
      .filter(page => !!page.userId && page.userId === userId);
    const questions = [];
    for (const page of filteredPages) {
      const feedback = feedbacks[page.userId];
      if (!feedback) {
        continue;
      }

      const answer = answers.find(i => i.survey_question === page.id && i.feedback === feedback.id);
      const values = page.category === 'communication' ? [answer.value] : answer.value.split(', ');
      const filteredValues = values.filter(i => !!i && i !== '');
      for (const val of filteredValues) {
        if (Number(val) > 0) {
          const statement = page.statements.find(i => i.id === Number(val));
          if (statement && !questions.includes(statement.text)) {
            questions.push(statement.text);
          }
        } else if (!questions.includes(val)) {
          questions.push(val);
        }
      }
    }

    return questions;
  }

  render() {
    const {
      survey,
      displayCheckMark = true,
      viewOnly = false
    } = this.props;

    const {
      show,
      questionsOrder,
      answers,
      isIntroScreen,
      isFinalScreen,
      isBeforeTransitionScreen,
      isTransitionScreen,
      showFeedbackError,
      currentPage,
      progressBar,
      self_assessment_count,
      peer_rating_count,
      skills_assessment_count,
      teamList,
      questionsCount,
      currentUserId,
      feedbacks,
      readonlyMode,
      showAlert,
      finishedFeedbacks,
      adjustedScore,
      submitButtonLoading,
      showSubmissionError
    } = this.state;

    const currentQuestion = questionsOrder[currentPage];
    const currentQuestionId = currentQuestion ? currentQuestion.id : null;
    const currentQuestionAnswers = answers.filter(answer => !!currentQuestionId && answer.survey_question === currentQuestionId);
    let hasAnswer = true;
    if (currentQuestion) {
      if (currentQuestion.category === "self_assessment" && feedbacks[currentUserId]) {
        hasAnswer = currentQuestionAnswers.filter(i => i.feedback === feedbacks[currentUserId].id).length >= 1;
      } else if (["collaboration", "peer_rating"].includes(currentQuestion.category)) {
        let feedbacksIds = [];
        for (const teammate of teamList) {
          if (feedbacks[teammate.id]) {
            feedbacksIds.push(feedbacks[teammate.id].id);
          }
        }
        hasAnswer = currentQuestionAnswers.filter(i => feedbacksIds.includes(i.feedback)).length >= teamList.length;
      } if (["communication", "other", "skills"].includes(currentQuestion.category)) {
        const answer = currentQuestionAnswers.find(i => i.feedback === feedbacks[currentQuestion.userId].id);
        hasAnswer = answer && !!answer.value && answer.value !== "";
      }
    }
    const previousAnswers = this.getPreviousAnswers(currentPage, currentQuestion ? currentQuestion.userId : null);

    const submitButtonText = submitButtonLoading
      ? <div><Loader type="ball-clip-rotate" active={true} /><span>Processing</span></div>
      : currentPage + 1 === questionsOrder.length - 1
        ? "Submit"
        : isBeforeTransitionScreen
          ? "Continue"
          : (isIntroScreen || isTransitionScreen)
            ? "Start"
            : "Save & Continue";

    return (
      <div className="peerEvaluation">
        <PeerEvaluationCard
          survey={survey}
          onClick={this.handleShowModal}
          isStarted={this.isSurveyStarted(survey)}
          isSubmitted={this.isSurveySubmitted()}
          isEnded={this.isSurveyEnded(survey)}
          isEndedWithExtended={this.isSurveyEndedWithExtended(survey)}
          isSurveyCompleted={this.isSurveyCompleted()}
          defaultPeerEvaluationCard={false}
          hasFeedbacks={this.isSurveyHasFeedbacks()}
          displayCheckMark={displayCheckMark}
          viewOnly={viewOnly}
          completedAt={finishedFeedbacks.length ? finishedFeedbacks[finishedFeedbacks.length - 1].completed_at : null}
        />
        <PeerEvaluationModal
          surveyId={survey.id}
          show={show}
          onHide={this.handleHideModal}
          onSubmit={this.goToNextPage}
          progressBar={progressBar}
          submitButtonText={submitButtonText}
          currentPage={currentPage ? Number(currentPage) : 0}
          countOfPages={questionsCount ? Number(questionsCount) : 0}
          goNext={this.goToNextPage}
          goPrev={this.goToPrevPage}
          canSubmit={hasAnswer}
          isFinalScreen={isFinalScreen}
          isTransitionScreen={isTransitionScreen}
          readonlyMode={readonlyMode}
        >
          {showAlert && <WarningAlert
            title="Warning! Incomplete"
            message="Your peer evaluation is not completed. Please make sure to complete your peer evaluation by the deadline.  "
            onSuccess={this.hideAlert}
            successButtonText="Got it"
            showCancel={false}
          />}
          {showSubmissionError && <ErrorAlert
            title="Submission failed"
            message="Submission failed. Please reach out to tech support (info@marketgames.io)."
            onHide={this.hideSubmissionError}
          />}
          {!!currentQuestion && (
            <PeerEvaluationFeedback
              question={currentQuestion}
              answers={currentQuestionAnswers}
              self_assessment_count={self_assessment_count}
              peer_rating_count={peer_rating_count}
              skills_assessment_count={skills_assessment_count}
              showError={showFeedbackError}
              onChange={result => this.handleFeedbackOnChange(result)}
              teamList={teamList}
              currentUserId={currentUserId}
              feedbacks={feedbacks}
              previousAnswers={previousAnswers}
              readonlyMode={readonlyMode}
              adjustedScore={adjustedScore}
            />
          )}
        </PeerEvaluationModal>
      </div>
    );
  }
}

export default PeerEvaluation;



// WEBPACK FOOTER //
// ./src/components/peer-evaluation/index.js